import fetch from '@/utils/fetch';

export function getGmTree(params){
     
     return fetch({

         url: 'Rule/Rule/getOrganizationAndPostTree',
         method:"post",
         data:params

     })

}

// zym.角色列表
export function getRoleList(params){     
     return fetch({
        //  url: 'Rule/Rule/getOrganizationAndPostList',
         url: 'manage/post/all',
         method:"post",
         data:params

     })

}

export function getConfiged(params){
     
     return fetch({

         url: 'Rule/Rule/getPostRuleTree',
         method:"post",
         data:params

     })

}

// zym.角色新增、修改
export function CreateRole(params){
     return fetch({
        //  url: 'Rule/Rule/addOrUdatePost',
         url: 'manage/post/addOrUdatePost',
         method:"post",
         data:params
     })
}

// zym.角色停用
export function removeRole(params){
     return fetch({
        //  url: 'Rule/Rule/delOrganizationAndPost',
         url: 'manage/post/delOrganizationAndPost',
         method:"post",
         data:params
     })
}

// 保存角色菜单权限
export function ropSave(params){     
     return fetch({
        //  url: 'Rule/Rule/savePostRule',
         url: 'manage/post/savePostRule',
         method:"post",
         data:params
     })
}

// zym.角色菜单权限
export function ropList(params){          
     return fetch({
        //  url: 'Rule/Rule/getPostRuleTree',
         url: 'manage/menu/getPostRuleTree',
         method:"post",
         data:params

     })

}

// zym.查询某个角色的菜单权限
export function dfPower(params){   //  获取职位默认权限     
  return fetch({
    //  url: 'Rule/Rule/getUserPostRuleTree',
      url: 'manage/post/getUserPostRuleTree',
      method:"post",
      data:params
  })
}


// WEBPACK FOOTER //
// ./src/api/pgMent/roleMent.js